import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const MODO = { prueba: "Prueba", completa: "Importación", sync: "Sincronización" };
const CHIP = { en_curso: "chip-amber", completado: "chip-emerald", completado_con_errores: "chip-amber", error: "chip-red", cancelado: "", interrumpido: "chip-red" };

export default function HistorialTrabajos({ onVer }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/migracion/trabajos").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e))); }, []);
  async function ver(id) { try { const { data } = await api.get(`/migracion/trabajos/${id}`); onVer(data); } catch (e) { toast.error(formatApiError(e)); } }
  return (
    <div className="surface-card" data-testid="historial-trabajos">
      <table className="w-full text-xs">
        <thead className="table-head"><tr><th className="text-left px-4 py-2">Fecha</th><th className="text-left px-4 py-2">Tipo</th><th className="text-left px-4 py-2">Etapas</th><th className="text-left px-4 py-2">Procesados</th><th className="text-left px-4 py-2">Estado</th><th className="text-left px-4 py-2">Por</th><th className="px-4 py-2" /></tr></thead>
        <tbody>
          {items.map((t) => {
            const proc = Object.values(t.progreso || {}).reduce((a, e) => a + (e.procesados || 0), 0);
            return (
              <tr key={t.id} className="border-t border-brand-line/70" data-testid={`trabajo-${t.id}`}>
                <td className="px-4 py-2 whitespace-nowrap">{new Date(t.created_at).toLocaleString("es-MX")}</td>
                <td className="px-4 py-2 font-semibold text-brand-ink">{MODO[t.modo] || t.modo}{t.muestra ? ` (${t.muestra})` : ""}</td>
                <td className="px-4 py-2 text-brand-muted">{(t.etapas || []).length} etapas</td>
                <td className="px-4 py-2 font-mono">{proc.toLocaleString()}</td>
                <td className="px-4 py-2"><span className={`chip h-6 px-2.5 ${CHIP[t.estado] || ""}`}>{t.estado.replace(/_/g, " ")}</span></td>
                <td className="px-4 py-2">{t.iniciado_por}</td>
                <td className="px-4 py-2 text-right"><button data-testid={`trabajo-ver-${t.id}`} onClick={() => ver(t.id)} className="text-brand-amber-dark font-semibold hover:underline">Ver detalle</button></td>
              </tr>
            );
          })}
          {!items.length && <tr><td colSpan={7} className="px-4 py-8 text-center text-brand-muted">Aún no se ha ejecutado ninguna migración.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
